<div class="row">
	<div class="col-md-12">
		<cache-date></cache-date>
	</div>
</div>

<hr/>

<div class="row">
	<div class="col-md-12">
		<div class="form-group">
			<ng-container *ngFor="let dateType of addFilterParams.dateFilters">
				{{ 'adminstat.filterForm.' + dateType | translate }}
				<select class="form-control" [(ngModel)]="filter.filterParams.dateFilterParams[dateType].type" [ngModelOptions]="{standalone: true}" [sextant]="'filter-dateType.' + dateType">
					<option *ngFor="let opt of ['all', 'now', 'yesterday', 'prevWeek', 'prevMonth', 'last7day', 'last30day', 'other']"
					        value="{{ opt }}" [selected]="opt == filter.filterParams.dateFilterParams[dateType].type">{{ 'adminstat.common.interval.' + opt | translate }}
					</option>
				</select>
				<table>
					<tr [style.display]="filter.filterParams.dateFilterParams[dateType].type != 'other' ? 'none' : null">
						<td>
							<datepicker [(ngModel)]="filter.filterParams.dateFilterParams[dateType].start" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
							<datepicker [(ngModel)]="filter.filterParams.dateFilterParams[dateType].end" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
						</td>
					</tr>
				</table>
			</ng-container>
			
			{{ 'adminstat.mails.mailer.site filter' | translate }}
			<input class="form-control" [(ngModel)]="filter.filterParams.siteUrl" [ngModelOptions]="{standalone: true}">
			
			<br><br>
			
			<button type="button" class="btn btn-success" (click)="applyFilters()" [sextant]="'btnApplyFilters'">{{ 'adminstat.common.Apply' | translate }}</button>
			<button type="button" class="btn btn-link" style="color:red;" (click)="resetFilters()">{{ 'adminstat.common.Reset filters' | translate }}</button>
		</div>
		
		<hr/>
	</div>
</div>


<div class="row">
	<div class="col-md-12">
		<loading [isLoad]="totalsLoader"></loading>

		<h4>
			{{ 'adminstat.common.All count' | translate }}: {{ totals.totalRec | prettyNumber }}
		</h4>

		<br/>

		<h4>
			{{ 'adminstat.billing.manual_paid.totalMoney' | translate }}: <br>
			
			<ul>
				<li *ngFor="let currency of currencyList">
					{{ currency }}: {{ totals[currency] | prettyNumber }} {{ helper.currencyLabels[currency] }}
				</li>
			</ul>
		</h4>
		
		<hr/>
	</div>
</div>


<div class="row">
	<div class="col-md-12">
		<chart
			[data]="paidChart.data"
			[options]="paidChart.options"
			[sextant]="'paidChart'" [url]="filter.currentUrl"
		></chart>
		
		<hr/>
	</div>
</div>


<div class="row">
	<div class="col-md-12">
		<chart
			[data]="paidByProcessorChart.data"
			[options]="paidByProcessorChart.options"
			[sextant]="'proccessorChart'" [url]="filter.currentUrl"
		></chart>
		
		<hr/>
	</div>
</div>


<div class="row">
	<div class="col-md-12">
		<chart
			[data]="paidByType.data"
			[options]="paidByType.options"
			[sextant]="'paidByTypeChart'" [url]="filter.currentUrl"
		></chart>
		
		<hr/>
	</div>
</div>



<loading [isLoad]="paginationLoader"></loading>
<div class="row" *ngIf="!paginationLoader && pagination.items.length > 1">
	<div class="col-md-12">
		<ngb-pagination
			[extlinks]="links"
			[collectionSize]="pagination.items.length"
			[maxSize]="10"
			[pageSize]="1"
			[(page)]="pagination.page"
			[boundaryLinks]="true"
			(pageChange)="onPageChange()"
		></ngb-pagination>
		
		<hr/>
	</div>
</div>


<div class="row">
	<div class="col-md-12">
		<span class="button-download-link float-left" (click)="downloadButton()">
			<i class="fa fa-download" aria-hidden="true"></i> КЦ
		</span>
	</div>
</div>

<div class="row">
	<div class="col-md-12">
		<loading [isLoad]="statsLoader"></loading>
		
		<table class="table">
			<thead>
				<tr>
					<th></th>
					
					<th>
						{{ 'adminstat.common.Date' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.common.Status' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.billing.billing.tariffId' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.billing.billing.tariffVariant' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.common.Site' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.common.Money' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.billing.manual_paid.payment type' | translate }}
					</th>
					
					<th>
						{{ 'adminstat.billing.manual_paid.payment category' | translate }}
					</th>
				</tr>
			</thead>
			
			<tbody>
				<tr
					*ngFor="let stat of stats"
				>
					<td></td>
					
					<td>
						{{ stat.date | dateFormat:'DD.MM.YYYY HH:mm' }}
					</td>
					
					<td *ngIf="stat.status === 'paid'">
						{{ 'adminstat.billing.manual_paid.success' | translate }}
						
						<span class="badge badge-primary" *ngIf="stat.usedPromocode">Promocode</span>
					</td>
					
					<td *ngIf="stat.status === 'not paid'">
						{{ 'adminstat.other.error' | translate }}
					</td>
					
					<td *ngIf="stat.status === 'paid'">
						{{ stat.tariffId }}
					</td>
					
					<td *ngIf="stat.status === 'not paid'">
						{{ 'adminstat.billing.manual_paid.code' | translate }}: <strong>{{ stat.errorCode }}</strong><br/>
						{{ 'adminstat.billing.manual_paid.text' | translate }}: <strong>{{ stat.errorText }}</strong><br/>
					</td>
					
					<td>
						{{ stat.tariffVariant }}
					</td>
					
					<td>
						
						
						<div style="width: 300px;">
							<site_info [siteUrl]="stat.techUrl"></site_info>
						</div>
					</td>
					
					<td>
						{{ stat.amount }} {{ helper.currencyLabels[stat.currency] }}
					</td>
					
					<td>
						{{ stat.processor }}
					</td>
					
					<td>
						{{ 'adminstat.billing.billing.invoicePaidType' + stat.invoicePaidType | translate }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
